import axios from 'axios'
import store from '@/store'
import localStorageService from '@/services/refresh.service'
import { SUPPORT_API_URL, SUPPORT_URL } from '@/components/support/config'

// API сервиса FAKT Support для сотрудника филиала (контракт T07, fakt-support
// frontend/src/shared/api/crm.ts). Отдельный инстанс: перехватчики CRM дописывают cur_filial_id и
// client_device_type, сервису поддержки они не нужны. Токен - тот же JWT сотрудника CRM.
const http = axios.create({ baseURL: SUPPORT_API_URL, timeout: 15000 })

http.interceptors.request.use((config) => {
  const token = localStorageService.getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`

  return config
})

// Токен протух: тем же refresh, что и CRM, обновляем один раз и повторяем. Второй отказ сессию
// CRM не трогает - выйти из CRM из-за сервиса поддержки было бы хуже, экран покажет ошибку.
http.interceptors.response.use(null, async (error) => {
  const config = error.config
  if (error.response?.status !== 401 || !config || config.supportRetried) throw error

  config.supportRetried = true
  await store.dispatch('auth/refresh')

  return http(config)
})

const branchId = () => store.getters['branches/getGlobalFilialId']

/** Код ошибки сервиса поддержки из { error: { code } }; нет ответа - network. */
export function supportErrorCode (e) {
  if (!e?.response) return 'network'

  return e.response.data?.error?.code || `http_${e.response.status}`
}

/** Текст ошибки для снекбара: бэк поддержки пишет его по-русски. */
export function supportErrorText (e, fallback = 'Сервис поддержки не ответил, попробуйте ещё раз') {
  return e?.response?.data?.error?.message || fallback
}

export default {
  me: () => http.get('/me', { params: { branchId: branchId() } }).then(r => r.data),

  appeals: (filter, page, perPage = 5) =>
    http.get('/appeals', { params: { branchId: branchId(), filter, page, perPage } }).then(r => r.data),

  appeal: id => http.get(`/appeals/${id}`, { params: { branchId: branchId() } }).then(r => r.data),

  /** before - createdAt самой старой записи (с микросекундами). */
  olderMessages: (id, before, limit = 50) =>
    http.get(`/appeals/${id}/messages`, { params: { branchId: branchId(), before, limit } }).then(r => r.data),

  /** Форма «Написать в поддержку»: обращение сразу new (или idea), не черновик. */
  create: body => http.post('/appeals', { ...body, branchId: branchId(), source: 'form' }).then(r => r.data),

  send: (id, body) => http.post(`/appeals/${id}/messages`, { ...body, branchId: branchId() }).then(r => r.data),

  /** Прочитать ответы; бэк заодно гасит уведомления этого обращения в колокольчике CRM. */
  read: id => http.post(`/appeals/${id}/read`, { branchId: branchId() }),

  solve: id => http.post(`/appeals/${id}/solve`, { branchId: branchId() }).then(r => r.data),

  rate: (id, score, comment = null) =>
    http.post(`/appeals/${id}/rating`, { branchId: branchId(), score, comment }).then(r => r.data),

  upload: (file) => {
    const form = new FormData()
    form.append('file', file)
    form.append('branchId', branchId())

    return http.post('/attachments', form).then(r => r.data)
  },

  /** Подписанная ссылка «Сохранить изображение»: браузер скачивает, а не открывает. */
  downloadUrl: id =>
    http.get(`/attachments/${id}/download`, { params: { branchId: branchId() } }).then(r => r.data.url),

  /** Без q - открытые заказы филиала; q от 3 цифр - поиск по всем, включая закрытые. */
  orders: q => http.get(`/branches/${branchId()}/orders`, { params: q ? { q } : {} }).then(r => r.data),

  /** Публичный ключ Reverb для сокета поддержки. */
  config: () => axios.get(`${SUPPORT_URL}/api/config`).then(r => r.data),
}
